import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { faSidebar } from "@fortawesome/pro-regular-svg-icons";

import { translationKeys } from "../../../models/app-translation-keys";
import { useStore } from "../../../stores/StoreContext";
import { ActionButton } from "../Buttons";

interface ISidebarToggleButtonProps {
  hide?: boolean;
  onClick: () => void;
}

const RawSidebarToggleButton: FunctionComponent<ISidebarToggleButtonProps> = (props: ISidebarToggleButtonProps) => {
  const { t } = useTranslation();
  const { sidebarStore, navigationStore } = useStore();

  const showTooltipKey =
    navigationStore.currentActiveMenuItem?.showSidebarTooltipKey || translationKeys.tooltip.showSidebar;
  const hideTooltipKey =
    navigationStore.currentActiveMenuItem?.hideSidebarTooltipKey || translationKeys.tooltip.hideSidebar;

  if (props.hide) {
    return null;
  }

  return (
    <ActionButton
      id="sidebar-toggle-button"
      icon={faSidebar}
      hideBackground={true}
      onClick={props.onClick}
      tooltip={t(sidebarStore.isCollapsed ? showTooltipKey : hideTooltipKey)}
    />
  );
};

export const SidebarToggleButton = observer(RawSidebarToggleButton);
